import { SERVER_URLS } from "../../../appConstants";
import { buildUrl } from "../../../ReusableFunctions/reusableFunctions";
import { getToken } from "../../authentication";

export const getCrmleads = async (filter) => {
  try {
    const token = getToken();
    const url = buildUrl(
      SERVER_URLS.BACKEND_SERVER + "/bhumeet_team/crm/leads",
      {
        fromDate: filter.fromDate ? filter.fromDate : undefined,
        toDate: filter.toDate ? filter.toDate : undefined,
        pageNumber: filter.currentPage ? filter.currentPage : undefined,
        pageSize: filter.pageSize ? filter.pageSize : undefined,
        interval: filter.interval ? filter.interval : undefined,
        state: filter.state ? filter.state : undefined,
        district: filter.district ? filter.district : undefined,
        taluka: filter.taluka ? filter.taluka : undefined,
        type: filter.type ? filter.type : undefined,
        is_dnd:
          filter.is_dnd !== null && filter.is_dnd !== undefined
            ? filter.is_dnd
            : undefined, // ✅
      },
    );
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const res = await response.json();
    if (!response.ok) {
      throw res.message;
    }
    return res;
  } catch (err) {
    throw err;
  }
};

export const getCrmleadsForAssignee = async (filter) => {
  try {
    const token = getToken();
    // console.log(filter)
    const url = buildUrl(
      SERVER_URLS.BACKEND_SERVER + "/bhumeet_team/crm/leads/assignee",
      {
        fromDate: filter.fromDate ? filter.fromDate : undefined,
        toDate: filter.toDate ? filter.toDate : undefined,
        status: filter.Status ? filter.Status : undefined,
        pageNumber: filter.currentPage ? filter.currentPage : undefined,
        pageSize: filter.pageSize ? filter.pageSize : 15,
        interval: filter.interval ? filter.interval : undefined,
        state: filter.state ? filter.state : undefined,
        district: filter.district ? filter.district : undefined,
        taluka: filter.taluka ? filter.taluka : undefined,
        target: filter.target ? filter.target : undefined,
      },
    );
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const res = await response.json();
    if (!response.ok) {
      throw res.message;
    }
    return res;
  } catch (err) {
    throw err;
  }
};

export const CreateCrmleads = async (Data) => {
  try {
    const token = getToken();
    const response = await fetch(
      `${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/crm/leads`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: Data,
      },
    );
    const res = await response.json();
    if (!response.ok) {
      throw res.message;
    }
    return res.message;
  } catch (err) {
    throw err;
  }
};

export const updateCrmleads = async (Data) => {
  try {
    const token = getToken();
    const response = await fetch(
      `${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/crm/leads`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(Data),
      },
    );
    const res = await response.json();
    if (!response.ok) {
      throw res.message;
    }
    return res.message;
  } catch (err) {
    throw err;
  }
};

export const createBulkCrmleads = async (Data) => {
  try {
    const token = getToken();
    const response = await fetch(
      `${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/crm/leads/bulk`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: Data,
      },
    );
    const res = await response.json();
    if (!response.ok) {
      throw res.message;
    }
    return res.message;
  } catch (err) {
    throw err;
  }
};

export const getCrmleadsInsight = async (filter) => {
  console.log("filer", filter);
  try {
    const token = getToken();
    // console.log(filter)
    const url = buildUrl(
      SERVER_URLS.BACKEND_SERVER + "/bhumeet_team/crm/leads/getLeadsInsight",
      {
        state: filter.state?.value ? filter.state?.value : undefined,
        district: filter.district?.value ? filter.district?.value : undefined,
        taluka: filter.taluka?.value ? filter.taluka?.value : undefined,
        target: filter.target?.value ? filter.target?.value : undefined,
        address: filter?.address ? filter?.address : undefined,
      },
    );
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const res = await response.json();
    if (!response.ok) {
      throw res.message;
    }
    return res;
  } catch (err) {
    throw err;
  }
};

export const getTalukaAndDistrict = async () => {
  try {
    const token = getToken();
    // console.log(filter)
    const url = buildUrl(
      SERVER_URLS.BACKEND_SERVER + "/bhumeet_team/crm/getTalukaAndDistrict",
      {},
    );
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const res = await response.json();
    if (!response.ok) {
      throw res.message;
    }
    return res;
  } catch (err) {
    throw err;
  }
};

export const importDNDCsv = async (data) => {
  try {
    const token = getToken();
    const response = await fetch(
      `${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/crm/leads/import-dnd`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      },
    );
    const res = await response.json();
    if (!response.ok) {
      throw res.message;
    }
    return res.message;
  } catch (err) {
    throw err;
  }
};
